import { render, staticRenderFns } from "./DescendantView.vue?vue&type=template&id=c05a7420&scoped=true&"
import script from "./DescendantView.vue?vue&type=script&lang=js&"
export * from "./DescendantView.vue?vue&type=script&lang=js&"
import style0 from "./DescendantView.vue?vue&type=style&index=0&id=c05a7420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05a7420",
  null
  
)

export default component.exports